export const TIME_STEP_MIN = 15;

export const ALL_TIMES: string[] = Array.from({ length: (24 * 60) / TIME_STEP_MIN }).map((_, i) => {
  const h = Math.floor((i * TIME_STEP_MIN) / 60);
  const m = (i * TIME_STEP_MIN) % 60;
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
});

export const ALL_END_TIMES: string[] = [...ALL_TIMES, '24:00'];

export function hhmmToMinutes(t: string) {
  const [h, m] = t.split(':').map(Number);
  return h * 60 + m;
}

export function minutesToHHmm(m: number) {
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return `${h.toString().padStart(2, '0')}:${mm.toString().padStart(2, '0')}`;
}
